module.exports = [
	{
		"group": "Movement",
		"order": 30000,
		"id": 4200,
		"name": "Smooth",
		"type": "Camera"
	},
	{
		"group": "Framing",
		"order": 20000,
		"id": 3700,
		"name": "Medium",
		"type": "Camera"
	},
	{
		"order": 50000,
		"id": 2200,
		"name": "Dark",
		"type": "Emotion"
	},
	{
		"group": "Time of day",
		"order": 40000,
		"id": 3500,
		"name": "Night",
		"type": "Setting"
	},
	{
		"order": 30000,
		"id": 300,
		"name": "Animals",
		"type": "Category"
	},
	{
		"order": 20000,
		"id": 200,
		"name": "Aerial",
		"type": "Category"
	},
	{
		"group": "Speed",
		"order": 10000,
		"id": 4300,
		"name": "Slow Motion",
		"type": "Camera"
	},
	{
		"group": "Movement",
		"order": 20000,
		"id": 4100,
		"name": "Shakey",
		"type": "Camera"
	},
	{
		"order": 150000,
		"id": 1500,
		"name": "Technology",
		"type": "Category"
	},
	{
		"order": 90000,
		"id": 900,
		"name": "Landscape",
		"type": "Category"
	},
	{
		"order": 100000,
		"id": 1000,
		"name": "Lifestyle",
		"type": "Category"
	},
	{
		"group": "Season",
		"order": 20000,
		"id": 2900,
		"name": "Summer",
		"type": "Setting"
	},
	{
		"order": 70000,
		"id": 700,
		"name": "Fitness",
		"type": "Category"
	},
	{
		"group": "Season",
		"order": 40000,
		"id": 3100,
		"name": "Winter",
		"type": "Setting"
	},
	{
		"order": 20000,
		"id": 1900,
		"name": "Sad",
		"type": "Emotion"
	},
	{
		"order": 10000,
		"id": 1800,
		"name": "Happy",
		"type": "Emotion"
	},
	{
		"order": 140000,
		"id": 1400,
		"name": "Sports",
		"type": "Category"
	},
	{
		"order": 120000,
		"id": 1200,
		"name": "People",
		"type": "Category"
	},
	{
		"order": 10000,
		"id": 100,
		"name": "Abstract",
		"type": "Category"
	},
	{
		"order": 110000,
		"id": 1100,
		"name": "Nature",
		"type": "Category"
	},
	{
		"group": "Location",
		"order": 20000,
		"id": 2700,
		"name": "Outside",
		"type": "Setting"
	},
	{
		"order": 30000,
		"id": 2000,
		"name": "Exciting",
		"type": "Emotion"
	},
	{
		"order": 160000,
		"id": 1600,
		"name": "Travel",
		"type": "Category"
	},
	{
		"group": "Movement",
		"order": 10000,
		"id": 4000,
		"name": "Static",
		"type": "Camera"
	},
	{
		"order": 105000,
		"id": 4600,
		"name": "Music",
		"type": "Category"
	},
	{
		"group": "Framing",
		"order": 10000,
		"id": 3600,
		"name": "Wide",
		"type": "Camera"
	},
	{
		"order": 40000,
		"id": 400,
		"name": "Business",
		"type": "Category"
	},
	{
		"order": 80000,
		"id": 800,
		"name": "Holidays",
		"type": "Category"
	},
	{
		"group": "Time of day",
		"order": 20000,
		"id": 3300,
		"name": "Day",
		"type": "Setting"
	},
	{
		"order": 50000,
		"id": 500,
		"name": "City & Urban",
		"type": "Category"
	},
	{
		"group": "Season",
		"order": 30000,
		"id": 3000,
		"name": "Fall",
		"type": "Setting"
	},
	{
		"order": 130000,
		"id": 1300,
		"name": "Religion",
		"type": "Category"
	},
	{
		"group": "Framing",
		"order": 40000,
		"id": 3900,
		"name": "Macro",
		"type": "Camera"
	},
	{
		"group": " ",
		"order": 30000,
		"id": 2500,
		"name": "High",
		"type": "Energy"
	},
	{
		"group": " ",
		"order": 20000,
		"id": 2400,
		"name": "Medium",
		"type": "Energy"
	},
	{
		"group": " ",
		"order": 10000,
		"id": 2300,
		"name": "Low",
		"type": "Energy"
	},
	{
		"group": "Time of day",
		"order": 30000,
		"id": 3400,
		"name": "Dusk",
		"type": "Setting"
	},
	{
		"group": "Season",
		"order": 10000,
		"id": 2800,
		"name": "Spring",
		"type": "Setting"
	},
	{
		"group": "Speed",
		"order": 20000,
		"id": 4400,
		"name": "Real Time",
		"type": "Camera"
	},
	{
		"group": "Speed",
		"order": 30000,
		"id": 4500,
		"name": "Timelapse",
		"type": "Camera"
	},
	{
		"order": 40000,
		"id": 2100,
		"name": "Chill",
		"type": "Emotion"
	},
	{
		"group": "Framing",
		"order": 30000,
		"id": 3800,
		"name": "Close-up",
		"type": "Camera"
	},
	{
		"order": 170000,
		"id": 1700,
		"name": "Worship",
		"type": "Category"
	},
	{
		"group": "Location",
		"order": 10000,
		"id": 2600,
		"name": "Inside",
		"type": "Setting"
	},
	{
		"group": "Time of day",
		"order": 10000,
		"id": 3200,
		"name": "Dawn",
		"type": "Setting"
	},
	{
		"order": 60000,
		"id": 600,
		"name": "Food & Drink",
		"type": "Category"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/assets/tags.json
// module id = 1072
// module chunks = 0 1 2 4 5 6 7 8